import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  FormGroup,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getMeetingByID, getOneEntity } from "http/fundLync/entityAndAddress.helper";
import { getOneDeal } from "http/fundLync/deal.helper";
import { dateFormat, decryptedValue } from "common/utility";


const ViewMeetingDetails = () => {
  const { id } = useParams();
  const Id = atob(id);
  const navigate = useNavigate();
 const user = decryptedValue(localStorage.getItem("user"));
 const [selectedEntity, setSelectedEntity] = useState('');
 const [dealName, setDealName] = useState('');
 
  const [meetingDetails, setMeetingDetails] = useState({
    id: "",
    title: "",
    date: "",
    start_time: "",
    end_time: "",
    meeting_status: "",
    description: "",
    location:"",
  });

  useEffect(() => {
    getMeetingByID({ Id: Id })
    .then((response) => {
        const formattedDate = response.date.split(" ")[0];
        const formattedStartTime = convertTo12HourFormat(response.startTime);
        const formattedEndTime = convertTo12HourFormat(response.endTime);
        
        setMeetingDetails({ ...response, 
          date: formattedDate ,
         // description: plainTextDescription,
          startTime: formattedStartTime,
          endTime: formattedEndTime 
        });

        getOneEntity({ entityId: response.entityId })
          .then((response) => {
            if (response.code === 200 && response.status) {
              setSelectedEntity(response.data[0]);
            }
          })
       
          if(!response.dealId){
            setDealName("-")
          }
          else{
            getOneDeal({ id: response.dealId })
            .then((response) => {
              setDealName(response?.dealName || '-');  
            })
          }
        

    }).catch((error) => {
      console.log(error)
    })

  }, [id]);

  const convertTo12HourFormat = (time) => {
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; 
    return `${hours}:${minutes} ${ampm}`;
};


  const handleCancel = () => {
    window.history.back();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Meeting Details" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Entity Name</Label>
                        <span className="mb-0 entityDetailsValue">{selectedEntity.entityName}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Deal Name</Label>
                        <span className="mb-0 entityDetailsValue">{dealName}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Meeting Title</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.title}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Meeting Date</Label>
                        <span className="mb-0 entityDetailsValue">{dateFormat(meetingDetails.date,'DD-MM-YYYY')}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Start Time</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.startTime}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">End Time</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.endTime}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Meeting Status</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.meetingStatus}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Timezone</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.timezone}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Medium</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.medium}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Meeting Location</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.location}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Meeting Description</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.description}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                        <Label className="d-block entityDetails">Invitees</Label>
                        <span className="mb-0 entityDetailsValue">{meetingDetails.invitees}</span>
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-end">
                    <Button
                      onClick={handleCancel}
                      color='secondary'
                      outline
                    >
                      Back
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewMeetingDetails;
